import { render, staticRenderFns } from "./CoozzyAdvertisementPreviewSideBarCard.vue?vue&type=template&id=2dd6e162&scoped=true"
import script from "./CoozzyAdvertisementPreviewSideBarCard.vue?vue&type=script&lang=js"
export * from "./CoozzyAdvertisementPreviewSideBarCard.vue?vue&type=script&lang=js"
import style0 from "./CoozzyAdvertisementPreviewSideBarCard.vue?vue&type=style&index=0&id=2dd6e162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd6e162",
  null
  
)

export default component.exports